import { render, staticRenderFns } from "./SearchResultsArticles.vue?vue&type=template&id=434c851e&scoped=true&"
import script from "./SearchResultsArticles.vue?vue&type=script&lang=js&"
export * from "./SearchResultsArticles.vue?vue&type=script&lang=js&"
import style0 from "./SearchResultsArticles.vue?vue&type=style&index=0&id=434c851e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434c851e",
  null
  
)

export default component.exports